import React from 'react';
import { motion } from 'framer-motion';
import { researchTrace } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpResearch() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-2477" data-mp="ptepoiixn1qe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-2478" data-mp="prtzt67kc6yv">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-2479" data-mp="ksr3qb9k9b31">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-2480" data-mp="fwa4akwwvaan">
            Built for scientific research
          </h2>
          <p className="text-xl text-ink-dark leading-relaxed mb-6" data-id="element-2481" data-mp="6uaotx1joe9t">
            SKP helps researchers connect ideas across studies, disciplines,
            and institutions. It links research questions, methods, study
            populations, interventions, and findings to their supporting
            sources, making it easier to compare results, examine
            disagreements, and identify connections worth investigating.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-2482" data-mp="2mtw8l8z3in5e">
            Through shared terminology, expert review, and knowledge graphs,
            SKP turns scattered research into knowledge that teams can search,
            explore, and build upon.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-7" data-id="element-2483" data-mp="2iu5i76dhe91e">
          <div className="bg-white border border-line rounded-lg p-8" data-id="element-2484" data-mp="36iy92of8xqp5">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-2485" data-mp="3aks68mq8gckk">A team can ask</p>
            <ol className="relative" data-id="element-2486" data-mp="3amw7ewwqyxh5">
              {researchTrace.map((row, index) => <li key={row.label} className="relative flex gap-5 pb-6 last:pb-0" data-id="element-2487" data-mp="2wt4ztu2ktno2" data-mpi={index}>
                  {index < researchTrace.length - 1 && <span aria-hidden="true" className="absolute left-[5px] top-4 bottom-0 w-px bg-line" data-id="element-2488" data-mp="3phixu9to0jzm" />}
                  <span className={`relative mt-1.5 w-[11px] h-[11px] rounded-full shrink-0 ${index === researchTrace.length - 1 ? 'bg-navy' : 'bg-white border-2 border-navy-light'}`} data-id="element-2489" data-mp="7z3max2twnj9" />
                  <div data-id="element-2490" data-mp="3u5sboo7nsg3w">
                    <p className="text-xs font-semibold text-ink-muted" data-id="element-2491" data-mp="3u50jlnd9t0id">{row.label}</p>
                    <p className="text-lg font-heading font-semibold text-ink-dark" data-id="element-2492" data-mp="3p6p7f5zi6dwz">
                      {row.value}
                    </p>
                  </div>
                </li>)}
            </ol>
            <p className="mt-8 pt-6 border-t border-line text-ink-muted leading-relaxed" data-id="element-2493" data-mp="3gdvpt1wl32fy">
              Conflicting findings remain visible for review rather than being
              flattened into a single unsupported conclusion.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}